module.exports = __webpack_public_path__ + "static/media/letter.a70c3af6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/letter.svg
// module id = 24
// module chunks = 0